import { createRoot } from "react-dom/client";

import PostHogProvider from "./components/providers/PostHogProvider.tsx";
import ReduxProvider from "./components/providers/ReduxProvider.tsx";
import BetterHtmlProvider from "./components/providers/BetterHtmlProvider.tsx";

import App from "./App.tsx";

import "./index.css";

createRoot(document.getElementById("root")!).render(
   <PostHogProvider>
      <ReduxProvider>
         <BetterHtmlProvider>
            <App />
         </BetterHtmlProvider>
      </ReduxProvider>
   </PostHogProvider>,
);
